// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.selWidth[data-v-5a73fdf6] {\n  width: 300px;\n}\n[data-v-5a73fdf6] .el-card__body {\n  padding: 20px 20px 0;\n}\n.block[data-v-5a73fdf6] {\n  padding-bottom: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
